import React, { useContext } from 'react';
import {
  Button,
  Typography,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { ArchivalAidMetadata, ArchivalUnitCopy } from 'types';
import { ApiRoute, GridBodyType, PageKey, SortOrder, UrlRoute } from 'enums';
import { GridEntityConfig } from 'components/grid/grid-types';
import { Grid } from 'components/grid/grid';
import { AuthCtx } from 'components/auth/auth-ctx';
import { loginRedirect } from 'utils';

import { ArchivalUnitDetail } from './archival-unit-detail';
import { ArchivalUnitQuote } from '../archival-unit/archival-unit-quote';
import { actionButtonsFactory } from 'components/grid/right-panel/action-buttons-factory';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginRequiredRoot: {
      minHeight: 'calc(100vh - 200px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(2),
      textAlign: 'center',
      padding: theme.spacing(2),
    },
  })
);

export const archivalUnitConfig: GridEntityConfig<
  ArchivalAidMetadata,
  ArchivalUnitCopy
> = {
  id: 'soukrome-archivalie',
  title: 'Archiválie (soukromá)',
  getLabel: (item) => `Archiválie (soukromá) - ${item.numericId?.toString()}`,
  getId: (item) => item.id,
  urlRoute: UrlRoute.ARCHIVAL_UNIT_PRIVATE,
  apiRoute: ApiRoute.ARCHIVAL_UNIT_PRIVATE,
  listApi: '/api/archival-unit/private/list',
  pageKey: PageKey.DETAIL_ARCHIVAL_UNIT_PRIVATE,
  ActionButtons: actionButtonsFactory([
    { id: 'download', label: 'Stáhnout metadata/popis' },
    { id: 'quote', Component: ArchivalUnitQuote },
  ]),
  icon: 'description',
  bodyComponents: { [GridBodyType.DETAIL]: ArchivalUnitDetail },
  params: {
    sort: [{ field: 'numericId', order: SortOrder.ASC }],
    filters: [{ field: 'metadataOnly', operation: 'EQ', value: 'false' }],
  },
};

export const archivalUnitGridConfig: any[] = [archivalUnitConfig];

export const ArchivalUnitPublicGrid = () => {
  const classes = useStyles();
  const { id } = useParams<{ id?: string }>();
  const { userInfo, userLoaded } = useContext(AuthCtx);

  const shouldShowLoginWarning = userLoaded && !userInfo && !!id;

  if (shouldShowLoginWarning) {
    return (
      <div className={classes.loginRequiredRoot}>
        <Typography variant="h5">
          Pro zobrazení soukromé archiválie je nutné přihlášení.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            loginRedirect(
              `${window.location.pathname}${window.location.search}${window.location.hash}`
            )
          }
        >
          Přihlásit se
        </Button>
      </div>
    );
  }

  return (
    <Grid
      gridConfig={archivalUnitGridConfig}
      leftPanelProps={{ hide: true }}
      centralPanelProps={{ hideTransitionButtons: true }}
    />
  );
};
